import React from "react";
import { QuestionDto } from "../../models/questionDto";
import { Container, Radio, Segment, Header } from "semantic-ui-react";
import { useStore } from "../../stores/store";
import { SurveySectionDto } from "../../models/surveySectionDto";
import parse from "html-react-parser";
import { useTranslation } from "react-i18next";

interface Params {
  isQuestion: boolean;
  question: QuestionDto;
  section: SurveySectionDto;
  onAnswerchange: (questionId: number, value: number | string | undefined) => void;
}

export default function SurveyItemViewer({ isQuestion, question, section, onAnswerchange }: Params) {
  const { commonStore } = useStore();
  const { t } = useTranslation("common");

  return (
    <>
      <Container>
        {question && !question.weighted && question.order === 0 && (
          <Segment inverted color="blue" className="survey-intro-header">
            <Header as="h1">{t("ExtraQuestions.PreSurveyQuestionTitle")}</Header>
          </Segment>
        )}
        {question && !question.weighted && question.order > 10 && (
          <Segment inverted color="blue" className="survey-intro-header">
            <Header as="h1">{t("ExtraQuestions.PostSurveyQuestionTitle")}</Header>
          </Segment>
        )}
        <Segment className="survey-question">
          <div className="quest-title">
            {question.weighted && parse(commonStore.getQuestionTitle(question))}
          </div>
          {"  "}
          <div className="quest-body">
            {question && question.isQuestion && parse(commonStore.getQuestionBody(question))}
          </div>
        </Segment>
        <Segment className="survey-answers">
          {question.isQuestion &&
            question?.choices.map((choice) => (
              <Radio
                key={choice.id}
                label={commonStore.getQuestionChoiceBody(choice)}
                value={choice.id}
                checked={question.selectedChoice === choice.id}
                onChange={(e, { value }) => {
                  onAnswerchange(question.id, value);
                }}
              />
            ))}
        </Segment>
      </Container>
    </>
  );
}
